// card types
export var RC = "RETAIL_CARD";
export var PSCC = "PAYMENT_SOLUTIONS_CARECREDIT";
// conditions
export var UPGRADING = "UPGRADING";
export var OPEN = "OPEN";
export var WAIVED_INTEREST = "WAIVED_INTEREST";
export var CLOSED = "CLOSED";
export var DELINQUENT = "DELINQUENT";
export var CLOSED_WITH_BALANCE = "CLOSED_WITH_BALANCE";
export var PRE_DELIVERY = "PRE_DELIVERY";
export var DORMANT = "DORMANT";
// product type
export var SETPAY = "SETPAY";
var PRODUCT_TYPE = {
    BUSINESS_RETAIL_CARD: "BUSINESS_RETAIL_CARD",
    DUAL_CARD: "DUAL_CARD",
    LIMITED_USE_DUAL_CARD: "LIMITED_USE_DUAL_CARD",
    PRIVATE_LABEL: "PRIVATE_LABEL",
    INSTALLMENT_LOAN: "INSTALLMENT_LOAN",
    INSTALLMENT_LOAN_PAY_IN_FOUR: "INSTALLMENT_LOAN_PAY_IN_FOUR",
    INSTALLMENT_LOAN_MONTHLY: "INSTALLMENT_LOAN_MONTHLY",
    INSTALLMENT_LOAN_SECURED: "INSTALLMENT_LOAN_SECURED",
};
export var LINE_OF_BUSINESS = {
    PAYMENT_SOLUTIONS_CARECREDIT: "PAYMENT_SOLUTIONS_CARECREDIT",
    RETAIL_CARD: "RETAIL_CARD",
    SECURED_INSTALLMENT: "SECURED_INSTALLMENT",
    SETPAY: "SETPAY",
};
export var LOAN_TYPES = [
    PRODUCT_TYPE.INSTALLMENT_LOAN,
    PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED,
    PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY,
    PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR,
];
export var SETPAY_LOANS = [
    PRODUCT_TYPE.INSTALLMENT_LOAN,
    PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY,
    PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR,
];
export var NON_SUPPORTING_PAG_CLIENTS = [
    "bp",
    "gemoney",
    "menswear",
    "stash",
];
export default PRODUCT_TYPE;
//# sourceMappingURL=products.js.map